import { render, staticRenderFns } from "./GymFull.vue?vue&type=template&id=a175ff6a&scoped=true"
import script from "./GymFull.vue?vue&type=script&lang=js"
export * from "./GymFull.vue?vue&type=script&lang=js"
import style0 from "./GymFull.vue?vue&type=style&index=0&id=a175ff6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a175ff6a",
  null
  
)

export default component.exports